import { Workflow, Database, Zap, BarChart } from "lucide-react";

export const ProcessSection = () => {
  const steps = [
    {
      icon: <Workflow className="h-12 w-12 text-blue-600" />,
      title: "Workflow Analysis",
      description: "We analyze your current processes to identify automation opportunities.",
    },
    {
      icon: <Database className="h-12 w-12 text-blue-600" />,
      title: "Data Integration",
      description: "Connect your tools and systems for seamless data flow.",
    },
    {
      icon: <Zap className="h-12 w-12 text-blue-600" />,
      title: "Automation Setup",
      description: "Build and deploy custom automation workflows.",
    },
    {
      icon: <BarChart className="h-12 w-12 text-blue-600" />,
      title: "Optimization",
      description: "Monitor and optimize workflows for maximum efficiency.",
    },
  ];

  return (
    <section className="py-20 bg-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center mb-12">
          Our Automation Process
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow"
            >
              <div className="mb-4">{step.icon}</div>
              <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
              <p className="text-gray-600">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};